<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-06-01 08:39:06
    Description : hdr 展映 的卡片
  -->
  <div class="gaia-card" @click="$emit('click')">
    <img class="cover" :src="getCover()" />
    <div class="time" style="opacity: 0"></div>
    <div class="encrypted"></div>
    <div class="info">
      <div class="title">{{ data.title }}</div>
      <div class="keywords">{{ `主讲 丨 ${data.author}` }}</div>
      <div class="line"></div>
      <div class="count">
        <play-one
          theme="filled"
          size="16"
          fill="#999999"
          style="margin-left: -3px"
        />
        <div class="playCount">{{ data.courseStatistics.visitCount }}</div>
        <book-open
          theme="filled"
          size="14"
          fill="#999999"
          style="margin: 0 6px 0 10px"
        />
        <div class="playCount">{{ data.courseStatistics.studentCount }}</div>
        <div class="width" style="width: 110px"></div>
        <template v-if="!isSelf">
          <template v-if="data.allowSee">
            <template v-if="data.displayPrice !== -2">
              <div class="first-price">
                {{
                  data.firstPrice > data.displayPrice
                    ? `¥${(data.firstPrice / 100).toFixed(2)}`
                    : ""
                }}
              </div>
              <div class="price">
                {{ (data.displayPrice / 100).toFixed(2) }}
              </div>
            </template>
            <template v-else>
              <div class="self">已购买</div>
            </template>
          </template>
        </template>
        <template v-else>
          <div v-if="data.allowSee" class="self">付费视频</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { PlayOne, BookOpen } from "@icon-park/vue";
import { timeConversion } from "@/utils/utils";
export default {
  components: {
    PlayOne,
    BookOpen,
  },
  props: {
    isSelf: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
    };
  },
  created() {},
  methods: {
    unescape(val) {
      return unescape(val);
    },
    getVideoDuration() {
      const data = this.data;
      if (data && data.video && data.video.videoInfo) {
        return timeConversion(data.video.videoInfo.duration);
      } else {
        return "-- : --";
      }
    },
    getCover() {
      const data = this.data;
      if (data.cover && !data.cover.includes("screenshot")) {
        return this.baseUrl + data.cover;
      }
      let cover = "";
      data.video.resources.map((el) => {
        if (el.resourceName === "180") {
          cover = this.baseUrl + el.resourceKey;
        }
      });
      return cover;
    },
  },
};
</script>

<style lang="less" scoped>
.gaia-card {
  display: inline-block;
  width: 275px;
  height: 270px;
  background: #ffffff;
  cursor: pointer;
  .cover {
    display: block;
    width: 100%;
    height: 154px;
    overflow: hidden;
  }
  .time {
    display: inline-block;
    position: relative;
    top: -40px;
    left: 210px;
    width: auto;
    max-width: 70px;
    height: 22px;
    line-height: 22px;
    padding: 0 7px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
  }
  .info {
    margin-top: -22px;
    padding: 14px 10px;
    .title {
      font-size: 15px;
      height: 38px;
      margin-bottom: 6px;
      font-weight: 700;
      color: #000000;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //作为弹性伸缩盒子模型显示。
      -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
      -webkit-line-clamp: 2; //显示的行
    }
    .line {
      width: 100%;
      height: 1px;
      background: #a7a7a7;
    }
    .keywords {
      font-size: 12px;
      margin-bottom: 6px;
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //作为弹性伸缩盒子模型显示。
      -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
      -webkit-line-clamp: 1; //显示的行
    }
    .count {
      height: 40px;
      padding-top: 4px;
      font-size: 12px;
      font-weight: bold;
      color: #a7a7a7;
      .playCount {
        display: inline;
        vertical-align: top;
      }
      .width,
      .first-price,
      .price {
        display: inline-block;
        font-size: 12px;
        vertical-align: top;
        text-align: right;
      }
      .first-price {
        width: 46px;
        text-decoration: line-through;
      }
      .price {
        width: 60px;
        color: #ff464c;
      }
      .price::before {
        color: #ff464c;
        content: "¥";
      }
      .self {
        display: inline-block;
        width: 100px;
        text-align: right;
        color: #4cc2ff;
      }
    }
  }
}
</style>